export const environment = {
  production: true,
  console: true,
  API_URL: "https://apipre.apiacpos.com/2_3_0_bridge",  
  CODIGO_APLICACION: "CUSTOMAN",
  ID_APLICACION: "19",
  chClaveEmpresa: "museocr",
  TICKETS_URL: "https://tickets.museocr.iacpospre.com/",
  chProyectoOnLine: "VENTAONLINE",
  chEntornoConexion: "DESARROLLO",
  chNombreProyecto: "CUSTOMMAN",
  chOrigenConexion: "CUSTOMMAN",
  NUMSERIE: "CUSTO$A$SZ45$A$MMAN$A$23g!.",
  API_MICROSERVICIOS: "https://apides.apiacpos.com/WebAPICoreBridge",
  VALIDATE_PERMISSIONS: true,
  API_TOKEN_USER: "admin@admin.com", 
  API_TOKEN_PASSWORD: "IACPOS.2023a+" 
};
